import EsriService from '../esri-service/esri-service.model';

export default class ArcgisList {
    public currentVersion = 0;
    public folders: string[] = [];
    public services: EsriService[] = [];

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.currentVersion) {
            this.currentVersion = model.currentVersion;
        }
        if (model.folders) {
            this.folders = model.folders;
        }
        if (model.services) {
            this.services = [];
            for (let i = 0; i < model.services.length; i++) {
                this.services.push(new EsriService(model.services[i]));
            }
        }
    }
}
